import React from 'react'
import {
  shallowEqual,
  useSelector,
} from 'react-redux'

import { GoogleMapsContextProvider } from 'utils/apis/googleGeocoding'

import { RootState } from 'state/types'

import { getInsuranceTypes } from 'state/insuranceTypes/selectors'

import { getQuoteRequestValue } from 'state/quotes/selectors'

import QuotingZipCode from './index.presentational'

const zipCodeRules = '^[0-9]{5}(-[0-9]{4})?$'

const QuotingZipCodeContainer: React.FC = (): React.ReactElement => {
  const applicantFirstName = useSelector((state: RootState) => getQuoteRequestValue(state, 'applicant.personalInfo.name.firstName'), shallowEqual)
  const applicantZipCode = useSelector((state: RootState) => getQuoteRequestValue(state, 'applicant.address.zipCode'), shallowEqual)
  const insuranceTypes = useSelector((state: RootState) => getInsuranceTypes(state), shallowEqual)

  return React.createElement(
    GoogleMapsContextProvider,
    null,
    React.createElement(
      QuotingZipCode,
      {
        applicantFirstName,
        applicantZipCode,
        insuranceTypes,
        zipCodeRules,
      },
    ),
  )
}

export * from './types'

export default QuotingZipCodeContainer
